module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.326eeb08.ttf";